import * as React from 'react';
import { connect } from 'react-redux';

import ActionLink from 'components/buttons/action-link/ActionLink';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { BlockTitle } from '../../admin-panel';

import {
  fetchProfilesWithDuplicatedChannels,
  resetProfilesWithDuplicatedChannels
} from 'modules/admin/reducers/admin-duplicated-profiles';

import { __t, applyTranslations } from 'utils/language';

import type { InfluencerProfile } from 'types';

import './profile-duplicated-profiles.scss';

applyTranslations(require('./profile-duplicated-profiles.i18n.json'));

type OwnProps = {
  profile: InfluencerProfile
};

type DuplicateProfile = {
  id: number,
  hidden: boolean
};

type StateProps = {
  duplicateProfiles: Array<DuplicateProfile>
};

type DispatchProps = {
  dispatchResetProfilesWithDuplicatedChannels: () => void,
  dispatchFetchProfilesWithDuplicatedChannels: (a: number) => void
};

type Props = OwnProps & StateProps & DispatchProps;


function getProfileLink(id: number): string {
  return `/content-creator/profiles/${id}`;
}

const ProfileDuplicatedProfiles: React.FunctionComponent<Props> = (
  {
    profile,
    duplicateProfiles,
    dispatchResetProfilesWithDuplicatedChannels,
    dispatchFetchProfilesWithDuplicatedChannels
  }: Props
) => {
  React.useEffect(() => {
    if (profile.id) {
      dispatchFetchProfilesWithDuplicatedChannels(profile.id);
    }

    return () => {
      dispatchResetProfilesWithDuplicatedChannels();
    };
  }, [profile.id]);

  if (duplicateProfiles.length === 0) {
    return null;
  }

  return (
    <section>
      <BlockTitle>
        <SVGDynamicIcon
          name="exclamation-inside-circle-custom-fg"
          customColor="red"
          width={16}
          height={16}
        />
        &nbsp;
        {__t('profile_duplicated_profiles.title')}
      </BlockTitle>
      <div className="profile-duplicated-profiles__link-section">
        {
          duplicateProfiles.map(duplicateProfile => {
            const url = getProfileLink(duplicateProfile.id);
            const text = `${url}${duplicateProfile.hidden ? ` ${__t('profile_duplicated_profiles.hidden')}` : ''}`;

            return (
              <ActionLink
                key={duplicateProfile.id}
                size="normal"
                link={url}
                openInNewTab
              >
                {text}
              </ActionLink>
            );
          })
        }
      </div>
    </section>
  );
};

const mapStateToProps = ({ adminDuplicatedProfiles }, { profile }): StateProps => ({
  duplicateProfiles: adminDuplicatedProfiles.duplicateProfiles[profile.id] || []
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchResetProfilesWithDuplicatedChannels: () => dispatch(resetProfilesWithDuplicatedChannels()),
  dispatchFetchProfilesWithDuplicatedChannels: profileId => dispatch(fetchProfilesWithDuplicatedChannels(profileId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDuplicatedProfiles);
